module.exports = __webpack_public_path__ + "static/img/15.4574ac0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/15.png
// module id = 0Hli
// module chunks = 0